<template>
  <div class="orders-filters">
    <AlgoliaSelectedFiltersWatcher />

    <AlgoliaDateFilter
      v-for="(dateFilter, index) in dateFilters"
      :key="index"
      :index="index"
      :dateFilter="dateFilter"
    />

    <!-- Selectable filters -->
    <AlgoliaSelectableFilters :arrFilters="arrFilters" />

    <!-- numeric filters -->
    <AlgoliaNumericFilters :numFilters="numFilters" />

  </div>
</template>

<script>
import AlgoliaNumericFilters from '@/components/general/AlgoliaNumericFilters'
import AlgoliaSelectableFilters from '@/components/general/AlgoliaSelectableFilters'
import AlgoliaDateFilter from '@/components/general/AlgoliaDateFilter2'
import AlgoliaSelectedFiltersWatcher from '@/components/general/AlgoliaSelectedFiltersWatcher'

export default {
  name: 'ReportOrdersFilters',
  components: {
    AlgoliaNumericFilters,
    AlgoliaSelectableFilters,
    AlgoliaDateFilter,
    AlgoliaSelectedFiltersWatcher
  },
  data () {
    return {
      arrFilters: [
        // { title: this.$i18n.t('orders.ref_number') + ' - ' + this.$i18n.t('orders.buyer'), attribute: 'buyer.order_ref', hideNumber: true },
        // { title: this.$i18n.t('orders.ref_number') + ' - ' + this.$i18n.t('orders.seller'), attribute: 'seller.order_ref', hideNumber: true },
        { title: this.$i18n.tc('companies.companies', 2) + ' - ' + this.$i18n.t('orders.buyer'), attribute: 'buyer.name' },
        { title: this.$i18n.tc('companies.companies', 2) + ' - ' + this.$i18n.t('orders.seller'), attribute: 'seller.name' },
        { title: this.$i18n.t('locations.address') + ' - ' + this.$i18n.t('orders.origin'), attribute: 'pickup.address' },
        { title: this.$i18n.t('locations.address') + ' - ' + this.$i18n.t('orders.destination'), attribute: 'delivery.address' },
        { title: this.$i18n.t('orders.status'), attribute: 'status', i18nPreffix: 'orders.' }
      ],
      numFilters: [
        { title: this.$i18n.t('orders.weight'), attribute: 'weight' },
        { title: this.$i18n.t('orders.volume'), attribute: 'volume' }
      ],
      dateFilters: [
        { title: this.$i18n.t('shipments.departure'), attribute: 'pickup.ts' },
        { title: this.$i18n.t('shipments.arrival'), attribute: 'delivery.ts', primary: true, default: { lengthInMonths: 4, futureInWeeks: 2 } }
      ]
    }
  }
}
</script>
